import { render, staticRenderFns } from "./SettingsIcon.vue?vue&type=template&id=9049b7c0"
import script from "./SettingsIcon.vue?vue&type=script&lang=ts"
export * from "./SettingsIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports